import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { DialogTransmitterEdit } from '../components/DialogTransmitterEdit';
import { ConfigTransmitterRow } from '../components/ConfigTransmitterRow';
import { newTransmitter } from '../actions/NewTransmitter';
export const ConfigTransmitters = (_props) => {
    const deviceMap = useAppSelector(state => state.definitions.devices);
    const dispatch = useAppDispatch();
    const transmitters = Object.values(deviceMap)
        .filter(d => {
        return ['nexa transmitter', 'hasta transmitter'].includes(d.protocol.name);
    })
        .sort((a, b) => {
        return a.title.localeCompare(b.title);
    });
    const rows = [];
    if (transmitters) {
        for (const t of transmitters) {
            rows.push(_jsx(ConfigTransmitterRow, { id: t.id }, t.id));
        }
    }
    return (_jsxs("div", { className: "page-container", children: [_jsx(DialogTransmitterEdit, {}), _jsx("div", { className: "operations", children: _jsx("button", { className: "lw success", onClick: () => dispatch(newTransmitter()), children: "\u00A0L\u00E4gg till s\u00E4ndare...\u00A0" }) }), _jsx("div", { className: "config-rows config-transmitters", children: rows })] }));
};
